import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import KeepAlive, { useActivate } from 'react-activation'
import { Col, Input, Row } from 'antd'
import { SendOutlined } from '@ant-design/icons'
import classNames from 'classnames'

import { GetUCenterAopMarketList, getUCenterAppList, getUCenterAppTypeList } from '@/services'
import SCItem from './SCItem'
import styles from './index.module.less'

const AppCenter = () => {
  const navigate = useNavigate()
  const [appList, setAppList] = useState<any>([])
  const [appTypeList, setAppTypeList] = useState<any>([])
  const [activeAppTypeKey, setActiveAppTypeKey] = useState<string>('0')
  const [searchName, setSearchName] = useState<string>('')

  useEffect(() => {
    getList()
  }, [])

  useActivate(() => {
    getList()
  })

  const getList = () => {
    Promise.all([GetUCenterAopMarketList(), getUCenterAppTypeList()]).then(resp => {
      const [appList, appTypeList] = resp
      setAppList(appList)
      setAppTypeList(
        appTypeList?.map(item => {
          return { ...item, id: item.id || '0' }
        })
      )
    })
  }

  const onSearch = (value: string) => {
    const name = value.trim()
    setSearchName(name)
  }

  const onDetail = code => {
    navigate('/main/appCenter/' + code)
  }

  return (
    <div className={styles.bg_container}>
      <div className={classNames([styles.top_img, styles.flex_center])}>
        <p className={styles.text_img}>展示无限可能</p>
        <div className={styles.input_border}>
          <Input
            className={styles.input}
            size={'large'}
            placeholder={'搜索'}
            onPressEnter={e => onSearch(e.target.value)}
            suffix={<SendOutlined className={styles.search_icon} />}
          />
        </div>
      </div>
      <div className={classNames([styles.content])}>
        <Row justify={'start'}>
          <Col span={3} className={styles.nav_aside}>
            <div className={styles.sticky_box}>
              {appTypeList.map(appType => (
                <div
                  key={appType.id}
                  onClick={() => setActiveAppTypeKey(appType.id)}
                  className={classNames([
                    styles.nav_title,
                    activeAppTypeKey === appType.id && styles.active_nav_title,
                  ])}
                >
                  {appType.name}
                </div>
              ))}
            </div>
          </Col>
          <Col span={20} className={styles.right_content}>
            <div className={classNames([styles.app_title])}>
              {appTypeList.find(item => item.id === activeAppTypeKey)?.name || ''}
            </div>
            <div>
              <Row gutter={[15, 15]}>
                {appList
                  .filter(app => {
                    if (activeAppTypeKey !== '0') {
                      return app.categoryId === activeAppTypeKey
                    }
                    if (searchName) {
                      return app.name.match(searchName) || app.briefIntroduce?.match(searchName)
                    }
                    return true
                  })
                  .map(item => {
                    return (
                      <Col key={item?.id} lg={12} xl={8} xxl={6}>
                        <SCItem data={item} handleFn={onDetail} />
                      </Col>
                    )
                  })}
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default function AppCenterPage(props) {
  const location = useLocation()

  return (
    <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
      <AppCenter {...props} />
    </KeepAlive>
  )
}
